export { default } from './SearchResult';
export type { Props, Props as SearchResultCardProps } from './SearchResult';
